// Runtime environment helpers shared by the web app and the Capacitor mobile
// app (the mobile shell wraps the same React build, so one codebase serves both).

/** True when the app runs inside the Capacitor native shell (Android/iOS). */
export const isNativeApp = () =>
  typeof window !== "undefined" && !!window.Capacitor && !!window.Capacitor.isNativePlatform?.();

/** Native platform name ("android" | "ios") or "web". */
export const nativePlatform = () => {
  try {
    if (isNativeApp()) return window.Capacitor.getPlatform();
  } catch { /* ignore */ }
  return "web";
};

//: Dove punta l'API quando il guscio non dichiara nient'altro. **Non** è un
//: default arbitrario: nel WebView l'origine è `capacitor://localhost` (iOS) o
//: `https://localhost` (Android) e serve solo i file del bundle, quindi una
//: base vuota non è "stessa origine" — è un'app che non parla con nessuno.
export const NATIVE_API_FALLBACK = "https://hostaly.it";

//: Chiave con cui l'app può correggere l'indirizzo dell'API (una build di
//: prova, uno staging) senza ricompilare. Vince sulla base "vuota", non su
//: `REACT_APP_BACKEND_URL`: quella è una decisione presa alla build.
export const API_BASE_OVERRIDE_KEY = "hh_api_base";

const clean = (v) => String(v || "").trim().replace(/\/+$/, "");

/**
 * API base URL for axios.
 *
 * - **Web**: `REACT_APP_BACKEND_URL` o "" (stessa origine: in produzione il
 *   processo FastAPI serve anche il frontend).
 * - **App nativa**: la variabile di build, poi l'override salvato in
 *   `localStorage`, poi `https://hostaly.it`. In un guscio non esiste una
 *   "stessa origine" da cui servire le API, quindi "" non è mai una risposta
 *   valida: senza questo fallback l'app si apriva e ogni schermata restava
 *   vuota (le richieste finivano su `capacitor://localhost/api/...`).
 */
export const apiBaseUrl = () => {
  const build = clean(process.env.REACT_APP_BACKEND_URL);
  if (!isNativeApp()) return build;
  let saved = "";
  try { saved = clean(localStorage.getItem(API_BASE_OVERRIDE_KEY)); } catch { /* storage negato */ }
  return build || saved || NATIVE_API_FALLBACK;
};
